export default __webpack_public_path__ + "static/media/add@3x.beb38682.png";